import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import type { VerificationDTO } from '@/types/auth/AuthDTOs';

export const sendRecoveryTwoFactorThunk = createAppAsyncThunk<
  VerificationDTO,
  { recoveryToken: string },
  { rejectValue: { message: string } }
>(
  'auth/sendRecoveryTwoFactor',
  async({ recoveryToken }, { extra: { authService }, rejectWithValue }) => {
    try {
      return await authService.sendRecoveryTwoFactor({ recoveryToken });
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to send recovery 2FA code';
      return rejectWithValue({ message });
    }
  }
);
